import { initialize as initWriterPopup } from '../../WriterPopup/redux/actions';
import { ModalType } from './types';
export default {
    [ModalType.JOURNAL]: initWriterPopup
};

//# sourceMappingURL=initActions.js.map